import { modalZIndex } from '../../../../contexts/PropertyPageModalContext/PropertyPageModalContext';

import { DisclaimerButton } from '../../BeforeYouBuyModal.styled';
import { Link, Tooltip, paletteHelper } from '@property.com.au/ui-kit';
import type { FunctionComponent } from 'react';
import styled from 'styled-components';

const StyledLink = styled(Link)`
  color: ${paletteHelper('textInverted')};
  font-weight: inherit;
  text-decoration: underline;

  &:hover {
    color: inherit;
  }
`;

const PrivacyPolicyLink: FunctionComponent = () => {
  return (
    <StyledLink
      href="https://www.realestate.com.au/legal/privacy-policy"
      target="_blank"
      rel="noreferrer"
    >
      Privacy Policy
    </StyledLink>
  );
};

const BeforeYouBuyDataCollectionDisclaimerText: FunctionComponent = () => {
  return (
    <p>
      If you purchase a report through Before You Buy (BYB), BYB will provide us with your contact
      details and information about the report you have purchased, so that we can contact you about
      other services that may be relevant to you. You may unsubscribe at any time. View our{' '}
      <PrivacyPolicyLink /> for further information.
    </p>
  );
};

export const BeforeYouBuyDataCollectionDisclaimer: FunctionComponent = () => {
  return (
    <Tooltip
      dangerouslySetClassNames={{
        tooltipContainer: 'tooltipContainer',
        contentWrapper: 'contentWrapper',
        closeButtonWrapper: 'closeButtonWrapper',
        closeButton: 'closeButton',
        triggerButton: 'triggerButton',
        icon: 'icon',
        elementPopoverClassNames: {
          overlay: 'elementPopover-overlay',
        },
      }}
      zIndex={modalZIndex + 1}
      placement="top"
      trigger={({ toggle }) => (
        <DisclaimerButton type="button" onClick={toggle}>
          Collecting your information
        </DisclaimerButton>
      )}
    >
      <BeforeYouBuyDataCollectionDisclaimerText />
    </Tooltip>
  );
};
